var _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurkey(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 800,
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#E30A17"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 400,
    r: 200,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 400,
    r: 160,
    style: {
      fill: "#E30A17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjgwMCI+CjxyZWN0IHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjgwMCIgZmlsbD0iI0UzMEExNyIvPgo8Y2lyY2xlIGN4PSI0MjUiIGN5PSI0MDAiIHI9IjIwMCIgc3R5bGU9ImZpbGw6I2ZmZmZmZiIvPgo8Y2lyY2xlIGN4PSI0NzUiIGN5PSI0MDAiIHI9IjE2MCIgc3R5bGU9ImZpbGw6I0UzMEExNyIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojZmZmZmZmIgogICBwb2ludHM9IjU4My4zMzQsNDAwIDc2NC4yMzUsNDU4Ljc3OSA2NTIuNDMxLDMwNC44OTQgNjUyLjQzMSw0OTUuMTA2IDc2NC4yMzUsMzQxLjIyMSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };